<template>
    <div>
        <div class="top">
            <van-nav-bar title="详情" left-text="返回" left-arrow @click-left="onClickLeft"/>
        </div>
        <div class="videoBox">
            <ul class="videoLi">
                <li v-for="(item,index) in videoList" :key="index" >
                    <div class="boxLi">
                        <video :src="item.video_url" autoplay controls v-if="item.palyVideo"></video>
                        <div class="coverBox" v-if="item.palyShow">
                            <div class="coverImg">
                                <img :src="item.thumb" alt="">
                            </div>
                            <div class="playImg" @click="clickPaly(item,index)">
                                <img src="../../assets/images/index/play.png" alt>
                            </div>
                        </div>
                    </div>
                    <div class="videoBottom">
                        <p class="videoName">{{item.title}}</p>
                        <div class="iconBox">
                           
                            <p>
                                <van-icon name="eye-o" size="1rem"/>
                                {{item.hits}}
                            </p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { httpGet, httpPost } from "../../axios/index";
export default {
    data(){
        return{
            videoList:[],
            videoId:this.$route.query.videoId,
            page:1
        }
    },
    methods:{
        // 返回上一页
        onClickLeft(){
            this.$router.go(-1);
        },
        // 播放视频
        clickPaly(item,index){
            for (let i = 0; i < this.videoList.length; i++) {
                if(this.videoList[i]==this.videoList[index]){
                        this.videoList[i].palyShow=false;
                        this.videoList[i].palyVideo=true;
                }else{
                      this.videoList[i].palyShow=true;
                        this.videoList[i].palyVideo=false;
                }            
              }
        },
        // 加载视频
        loadvideoDetail(){
           
              httpPost("/index/vidio_detail", {
                  id: this.videoId,
                    page: 1
                }).then(response => {
                   
                  if(response.code==1){
                        for (let i = 0; i < response.data.length; i++) {
                         response.data[0].palyShow=false;
                        response.data[0].palyVideo=true;
                        response.data[i].palyShow = true;
                        response.data[i].palyVideo = false;
                    }
                    this.videoList=response.data;
                  }
                });
          
        }
    },
    mounted(){
        this.loadvideoDetail();
    }
}
</script>

<style>
.videoLi .boxLi{
    width: 100%;
    height: 14rem;
    position: relative;
}
.videoBottom{
    width: 92vw;
    margin: 0 auto;
    color: rgb(153, 153, 153);
    font-size: 1rem;
    padding: 0.5rem 0;
    font-weight: bold;
}
.boxLi video{
    width: 100%;
    height: 100%;
}
.iconBox{
    margin-top: 0.4rem;
    font-size: 0.8rem;
    display: flex;
    justify-content: space-between;
}
.iconBox p{
    display: flex;
    align-items: center;
}
.iconBox .van-icon{
    margin-right: 0.6rem;
}
.coverBox{
    position: absolute;
    top: 0;
    width: 100%;
    height: 14rem;
}
.coverImg{
    width: 100%;
    height: 14rem;
    background: #000;
}
.coverImg img{
    width: 100%;
    height: 14rem; 
}
.playImg{
  position: absolute;
  width: 3rem;
  height: 3rem;
  top: 5rem;
  left: 44%;
}
.playImg img{
    border-radius: 50%;
    background: #000;
    opacity: 0.5;
}

</style>